import React, { useRef, useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { SearchBar } from "@pages/Other/Search/Search";
import CategoryList from "@pages/Other/CategoryList/CategoryList";
import { CartPreview } from "@pages/Dashboard/ShoppingCart/CartPreview/CartPreview";
import ProfileOptionsWrapper from "@pages/Dashboard/ProfileOptions/ProfileOptionsWrapper";

import "./topbar.scss";
import MobileDrawer from "./MobileDrawer";
import DesktopNav from "./DesktopNav";
import TopBarLogo from "./TopBarLogo";
import { categoryActions } from "@/_actions/category.actions";
import { courseActions } from "@/_actions";

const TopBar = (props) => {
  const courseMenuRef = useRef(null);
  const languageMenuRef = useRef(null);
  const topbarRef = useRef(null);
  const dispatch = useDispatch();
  
  const [manageLanguage, setManageLanguage] = useState(false);
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [manageCourse, setManageCourse] = useState(false);
  const [manageLanguageSlide, setManageLanguageSlide] = useState(false);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    function handleClickOutside(event) {
      if (languageMenuRef.current && !languageMenuRef.current.contains(event.target)) {
        setManageLanguage(false);
      }
      if (courseMenuRef.current && !courseMenuRef.current.contains(event.target)) {
        setManageCourse(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [courseMenuRef, languageMenuRef]);

  useEffect(() => {
    const scrollHandler = () => {
      if (!topbarRef.current) return;
      if (window.scrollY > 50) {
        topbarRef.current.classList.add("scrolled");
      } else {
        topbarRef.current.classList.remove("scrolled");
      }
    };
    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  const changeLanguage = (e, lng) => {
    e.stopPropagation();
    localStorage.setItem("language", lng);
    i18n.changeLanguage(lng);
    setManageLanguage(false);
    setToggleDrawer(false);
  };

  const handlers = {
    manageLanguage: () => {
      setManageLanguage(!manageLanguage);
      setManageCourse(false);
    },
    manageLanguageSlide: () => setManageLanguageSlide(!manageLanguageSlide),
    drawerToggle: () => setToggleDrawer(!toggleDrawer),
    slide: () => setToggleDrawer(true),
    manageCourse: () => {
      setManageCourse(!manageCourse);
      setManageLanguage(false);
    },
    courseSelect: () => setManageCourse(false),
    manageToggle: () => setToggleDrawer(false)
  };
 
  useEffect(() => {
    dispatch(courseActions.handleResetCourseList());
    dispatch(courseActions.fetchCourses());
    dispatch(categoryActions.getCategories());
  }, [dispatch]);

  return (
    <>
      <nav 
        id="topbar" 
        ref={topbarRef}
        className="fixed top-0 left-0 w-full z-[100] bg-white/95 backdrop-blur-md border-b border-slate-100/80 transition-all duration-300"
      >
        <div className="max-w-[1440px] mx-auto px-4 md:px-8 h-16 flex items-center justify-between gap-4">
          
          {/* Left section: Logo & Explore Dropdown */}
          <div className="flex items-center gap-4">
            <TopBarLogo />
             <div className="hidden lg:block flex-1 max-w-md mx-4">
            <SearchBar />
          </div>
          </div>

          {/* Middle section: Search Bar */}
         
          <div className="hidden lg:block  ">
              <CategoryList />
            </div>

          {/* Right section: Links & Profile / Actions */}
          <div className="flex items-center gap-5">
            <div className="hidden xl:block">
              <DesktopNav />
            </div>

            {/* Cart & Profile / Login & Register */}
            <div className="flex items-center gap-4 border-l border-slate-100 pl-4">
              {props.loggedIn ? (
                <div className="flex items-center gap-4">
                  <CartPreview />
                  <ProfileOptionsWrapper link="dashboard" label="Dashboard" />
                </div>
              ) : (
                <div className="flex items-center gap-3.5">
                  <Link 
                    className="text-slate-600 hover:text-blue-600 font-semibold text-sm transition-all no-underline" 
                    to="/login"
                  >
                    {t("Login")}
                  </Link>
                  <Link 
                    className="bg-blue-600 hover:bg-blue-700 active:scale-95 text-white font-bold text-sm px-4.5 py-2 rounded-xl transition-all shadow-md shadow-blue-500/10 no-underline" 
                    to="/register"
                  >
                    {t("Signup")}
                  </Link>
                </div>
              )}

              {/* Mobile Drawer Trigger */}
              <button 
                onClick={handlers.drawerToggle}
                className="xl:hidden flex flex-col justify-center items-center gap-1.5 w-9 h-9 rounded-lg hover:bg-slate-50 transition-all text-slate-600 border-none bg-transparent"
                aria-label="Toggle Mobile Menu"
              >
                <span className="w-5.5 h-0.5 bg-current rounded-full" />
                <span className="w-5.5 h-0.5 bg-current rounded-full" />
                <span className="w-5.5 h-0.5 bg-current rounded-full" />
              </button>
            </div>
          </div>

        </div>
      </nav>

      <MobileDrawer 
        isOpen={toggleDrawer}
        onClose={handlers.drawerToggle}
        manageLanguageSlide={manageLanguageSlide}
        onLanguageSlideToggle={handlers.manageLanguageSlide}
        onLanguageChange={changeLanguage}
        onManageToggle={handlers.manageToggle}
        props={props}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  loggedIn: state.authentication.loggedIn,
  user: state.users.user
});

export default connect(mapStateToProps)(TopBar);
